// extracted by mini-css-extract-plugin
module.exports = {"order":"_1B23YmnU","order-label":"_1wE24Fig","order-value":"oZdI-wQW","total":"AI8iGmF1","total-label":"_2JgWsPxf","total-value":"_2eq0ZGWI","actions":"CCRM61nz"};